import {
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@fluentui/react-components";
import { useMfaScanAuthenticatorQr } from "./mfaScanAuthenticatorQr/useMfaScanAuthenticatorQr";
import { translate } from "@/config/translator";
import { QRCodeSVG } from "qrcode.react";
import Skeleton from "react-loading-skeleton";
import PspTextInput from "@/components/pspTextInput/pspTextInput";
import PspButton from "@/components/pspButton/PspButton";
import { TotpSecret } from "./mfaScanAuthenticatorQr/totpSecret";
import { Dispatch, SetStateAction } from "react";
import { MfaSetupContext } from "../useMfaSetup";

type MfaScanAuthenticatorQrProps = {
  onNext: () => void;
  onBack: () => void;
  setMfaSetupContext: Dispatch<SetStateAction<MfaSetupContext>>;
};

export function MfaScanAuthenticatorQr({
  onBack,
  onNext,
  setMfaSetupContext,
}: MfaScanAuthenticatorQrProps) {
  const {
    lang,
    authenticatorData,
    onCopySecret,
    showCopyCheckmark,
    totpCode,
    onNextWrapper,
    isTablet,
    showWrongTotpCodeWarning,
    onChangeTotp,
  } = useMfaScanAuthenticatorQr({ onNext, setMfaSetupContext });

  return (
    <>
      <DialogTitle>{translate("setup2FaTitle", lang)}</DialogTitle>
      <DialogContent className="flex flex-col gap-6 tablet:gap-0">
        <p className="text-font-secondary">
          {translate(
            isTablet
              ? "mfaScanAuthenticatorQrBody"
              : "mfaAuthenticatorSetupMobile",
            lang,
          )}
        </p>

        {isTablet ? (
          <div className="mb-8">
            <div className="flex flex-col items-center border border-neutral rounded-md py-6 my-6">
              {authenticatorData ? (
                <QRCodeSVG
                  width={200}
                  height={200}
                  value={authenticatorData.uri}
                />
              ) : (
                <Skeleton width={200} height={200} />
              )}

              {/* DIVIDER */}
              <div className="flex flex-row justify-center w-full py-6">
                <div className="flex flex-row items-center w-[61.8%] gap-2">
                  <div className="h-px w-full bg-neutral grow" />
                  <div className="text-font-secondary">
                    {translate("orPreposition", lang)}
                  </div>
                  <div className="h-px w-full bg-neutral grow" />
                </div>
              </div>

              <TotpSecret
                authenticatorData={authenticatorData}
                onCopySecret={onCopySecret}
                showCopyCheckmark={showCopyCheckmark}
              />
            </div>

            <PspTextInput
              label="totpCode"
              invalidDataMessage={
                showWrongTotpCodeWarning ? "theCodeIsIncorrect" : undefined
              }
              disabled={!authenticatorData}
              placeholder="totpPlaceholder"
              value={totpCode}
              onChange={onChangeTotp}
            />
          </div>
        ) : (
          <div className="flex flex-col items-center w-full">
            <div className="flex flex-col items-center pb-8 gap-8 w-fit">
              <TotpSecret
                authenticatorData={authenticatorData}
                onCopySecret={onCopySecret}
                showCopyCheckmark={showCopyCheckmark}
              />

              <PspTextInput
                invalidDataMessage={
                  showWrongTotpCodeWarning ? "theCodeIsIncorrect" : undefined
                }
                label="totpCode"
                disabled={!authenticatorData}
                placeholder="totpPlaceholder"
                value={totpCode}
                onChange={onChangeTotp}
              />
            </div>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <PspButton appearance="secondary" onClick={onBack}>
          {translate("back", lang)}
        </PspButton>
        <PspButton
          appearance="primary"
          disabled={totpCode.replace(" ", "").length !== 6}
          onClick={onNextWrapper}
        >
          {translate("continue", lang)}
        </PspButton>
      </DialogActions>
    </>
  );
}
